// Fetches approved reviews from the companion app and renders them as a
// continuously-scrolling marquee. Used on both the homepage and product
// pages — same shared pool of reviews on both, not filtered per-product.
(function () {
  function escapeHtml(value) {
    var div = document.createElement("div");
    div.textContent = value == null ? "" : String(value);
    return div.innerHTML;
  }

  function starsMarkup(rating) {
    var out = "";
    for (var i = 1; i <= 5; i++) {
      var filled = i <= rating;
      out +=
        '<svg viewBox="0 0 24 24" ' +
        (filled ? 'fill="currentColor">' : 'fill="none" stroke="currentColor" stroke-width="1.5">') +
        '<path d="M12 2l2.9 6.9 7.1.6-5.4 4.7L18.2 21 12 17.3 5.8 21l1.6-6.8L2 9.5l7.1-.6z"/></svg>';
    }
    return out;
  }

  function cardMarkup(review) {
    return (
      '<div class="marika-reviews-marquee__card">' +
      '<div class="marika-reviews-marquee__stars" aria-hidden="true">' +
      starsMarkup(review.rating) +
      "</div>" +
      '<p class="marika-reviews-marquee__quote">&ldquo;' +
      escapeHtml(review.comment) +
      "&rdquo;</p>" +
      '<p class="marika-reviews-marquee__author">' +
      escapeHtml(review.customerName) +
      (review.productTitle
        ? '<span class="marika-reviews-marquee__product"> &middot; ' + escapeHtml(review.productTitle) + "</span>"
        : "") +
      "</p>" +
      "</div>"
    );
  }

  function init() {
    var root = document.querySelector("[data-marika-reviews-marquee]");
    if (!root) return;

    var track = root.querySelector("[data-marika-reviews-track]");
    var emptyState = root.querySelector("[data-marika-reviews-empty]");

    fetch(root.dataset.proxyUrl + "?limit=20", { headers: { Accept: "application/json" } })
      .then(function (response) {
        if (!response.ok) throw new Error("fetch_failed");
        return response.json();
      })
      .then(function (data) {
        var reviews = (data && data.reviews) || [];
        if (!reviews.length) {
          if (emptyState) emptyState.hidden = false;
          return;
        }

        var cardsHtml = reviews.map(cardMarkup).join("");
        // Duplicate the set so the CSS animation can loop seamlessly from
        // -50% back to 0 without a visible jump.
        track.innerHTML = cardsHtml + cardsHtml;
        root.hidden = false;
      })
      .catch(function () {
        // Best-effort — a failed fetch just leaves the section hidden.
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
